module.exports = __webpack_public_path__ + "img/10.5359b8cd.png";